import { render, staticRenderFns } from "./TipsBlock.vue?vue&type=template&id=33859c10&scoped=true&"
import script from "./TipsBlock.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TipsBlock.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TipsBlock.vue?vue&type=style&index=0&id=33859c10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33859c10",
  null
  
)

export default component.exports